import AddEditTeamModal from './AddEditTeamModal';

export default AddEditTeamModal;
